'use strict';
const angular = require('angular');

/*@ngInject*/
export function ContactsService($resource) {
  return $resource('/api/contacts/:id', {
    id: '@_id'
  },{
    update: {
      method: 'PUT'
    },
    patch: {
      method: 'PATCH'
    },
    addAttachments: {
      method: 'PUT',
      url: "/api/contacts/:id/attachments"
    },
    getEVotingConsent: {
      method: 'GET',
      url: "/api/contacts/:contactId/e-voting-consent"
    },
    updateEVotingConsent: {
      method: 'PUT',
      url: "/api/contacts/:contactId/e-voting-consent"
    },
    queryDT: {
      method: 'POST',
      url: '/api/contacts/datatables'
    }
  });
}


export default angular.module('conduu.ContactService', [])
  .factory('ContactService', ContactsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/contacts/contacts.service.js